#import "./PracticeRecordingDetails.graphql"
query SharedPracticeRecordingsQuery($studentId: ID!) {
  sharedPracticeRecordings(studentId: $studentId) {
    ...practiceRecordingDetails
  }
}
